import { render } from "./ProfileCardButtonInternal.vue?vue&type=template&id=1c278d28&scoped=true"
import script from "./ProfileCardButtonInternal.vue?vue&type=script&lang=js"
export * from "./ProfileCardButtonInternal.vue?vue&type=script&lang=js"

import "./ProfileCardButtonInternal.vue?vue&type=style&index=0&id=1c278d28&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c278d28"]])

export default __exports__